import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import store from '@/store/smartclass';
import { REDIRECT_ACTION_SUCCESS } from '@/action-types/redirect';
import { CHANGE_PAGE } from '@/action-types/app';
import { TOGGLE_SIDEBAR_REQUEST } from '@/action-types/sidebar';

// Дозволяє робити редіректи в сагах
const useRedirects = () => {
  const router = useRouter();

  useEffect(() => {
    const handleStoreChange = () => {
      const { redirect: { path, state, withNativeRedirect } } = store.getState() as any;

      if (path) {
        store.dispatch({ type: REDIRECT_ACTION_SUCCESS });

        if (withNativeRedirect) {
          window.history.pushState({}, '', path);
        } else {
          router.push(path);
        }

        store.dispatch({
          type: CHANGE_PAGE,
          pathname: path,
          state,
        });

        store.dispatch({ type: TOGGLE_SIDEBAR_REQUEST, isOpen: false });
      }
    };

    const unsubscribe = store.subscribe(handleStoreChange);

    return () => unsubscribe();
  }, []);
};

export default useRedirects;
